<div class=" row d-print-none bg-header" *ngIf="IsShow">

  <div class="col-md-2">
    <div class="float-left justify-content-center">
      <a class="btn ml-2 header-text " (click)="Logout()">
        <mat-icon aria-hidden="false" *ngIf="user" aria-label="Example login icon">logout</mat-icon>
        {{ user.username }}
      </a>
    </div>
  </div>
  <div class="text-center col-md-10">
    <a class="btn ml-2 header-text  " (click)="CheckPermit()" *ngFor="let item of items" [routerLink]="item.routerLink">
      {{item.label}}
    </a>

  </div>
</div>